export default __webpack_public_path__ + "da5076afd32f5316af22aca81edcce35.png";